import React from 'react';
import ApplClassTag from 'src/components/layout/tag/ApplClassTag';
import { IResPatentRights } from 'src/types/api/patentRightsApiTypes';
import { PrimaryColors } from 'src/types/globalTypes';
import { rowComponents } from 'src/utils/indexs';
import {
  Wrapper,
  Card,
  MobileContent,
  MobileItem,
  MobileTitle,
  MobileItemContent,
} from 'src/components/contents/search/result/TmarkResultMobile';
interface IProps {
  data: IResPatentRights[];
  colorType: PrimaryColors;
  handleOnClick: (applNo: string, applyClass: string) => void;
}

const PatentResultMobile: React.FC<IProps> = ({ data, colorType, handleOnClick }) => {
  const borderColor = colorType.third;
  const linkColor = colorType.seventh;

  // 表格常數
  const SEPRATOR = '，'; //名稱間隔
  
  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLElement>, 
    callback: () => void
  ): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback();
    }
  };

  return (
    <Wrapper color={borderColor}>
      {data.map((item, index) => {
        index += 1;
        return (
          <Card key={index} color={borderColor}>
            <MobileContent>
              <MobileItem>
                <ApplClassTag type={item.applyClass} />
              </MobileItem>
              <MobileItem>
                <MobileTitle>證書號數：</MobileTitle>
                <MobileItemContent>{item.patentNo}</MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>申請案號：</MobileTitle>
                <MobileItemContent>{item.applNo}</MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>發明人：</MobileTitle>
                <MobileItemContent>{rowComponents(item.inventorNameC, SEPRATOR)}</MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>申請人：</MobileTitle>
                <MobileItemContent>{rowComponents(item.applNameC, SEPRATOR)}</MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>專利名稱：</MobileTitle>
                <MobileItemContent
                  style={{ color: linkColor, cursor: 'pointer' }}
                  onClick={() => handleOnClick(item.applNo, item.applyClass)}
				  tabIndex={0}
				  role="button"
				  onKeyDown={(e) => handleKeyDown(e, () => handleOnClick(item.applNo, item.applyClass))}
                >
                  {item.patentName}
                </MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>申請日期：</MobileTitle>
                <MobileItemContent>{item.applyDate}</MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>年費有效日期：</MobileTitle>
                <MobileItemContent>{item.chargeExpiredDate}</MobileItemContent>
              </MobileItem>
            </MobileContent>
          </Card>
        );
      })}
    </Wrapper>
  );
};

export default PatentResultMobile;
